import angular from 'angular';

export class SliderComponent {
  $state;
  $scope;
  $rootScope;
  auth;

  constructor($state, $scope, $rootScope, Auth) {
    'ngInject';

    this.$state = $state;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.auth = Auth;

    $scope.$watch('slider.ngModel', function (newValue, oldValue) {
      $scope.slider.inputModel = newValue;
      setTimeout($scope.slider.ngChange, 0);
    });

    $scope.$watch('slider.inputModel', function (newValue, oldValue) {
      $scope.slider.ngModel = parseInt(newValue);
    });
  }

  $onInit() {
  }
}

export default angular.module('directives.slider', [])
  .component('slider', {
    bindings: {
      min: '@',
      max: '@',
      caption: '@',
      ngModel: '=',
      ngChange: '&',
    },
    template: require('./slider.html'),
    controller: SliderComponent,
    controllerAs: 'slider'
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/slider/slider.component.js